import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import TypewriterText from "../components/TypeWriterText";

const pages = [
  { title: " Curators Foreword", path: "/foreword-contemporary-institutes" },

  {
    title: "Day 51: The Birth of Banks",
    path: "/contemporaryfinance-51",
  },
  {
    title: "Day 52: The Origins and Modern Architecture of Fiat Money",
    path: "/contemporaryfinance-52",
  },
  {
    title: "Day 53: Creation and Destruction of Fiat Money",
    path: "/contemporaryfinance-53",
  },
  {
    title: "Day 54: Fiat Money and The Decline of Civilization",
    path: "/contemporaryfinance-54",
  },
  {
    title: "Day 55: Impact of Fiat Money on Food",
    path: "/contemporaryfinance-55",
  },
  {
    title: "Day 56: Impact of Fiat Money on Education",
    path: "/contemporaryfinance-56",
  },
  {
    title: "Day 57: Fiat Money and the Rise of Wokeism",
    path: "/contemporaryfinance-57",
  },
  {
    title: "Day 58: Case Study - Inflation in Weimar Germany I",
    path: "/contemporaryfinance-58",
  },
  {
    title: "Day 59: Case Study - Inflation in Weimar Germany II",
    path: "/contemporaryfinance-59",
  },

  {
    title: "Day 60: Altcoins are Fiat in Disguise",
    path: "/contemporaryfinance-60",
  },
];

const IndexFinance = () => {
  // State for staggered animation
  const [visibleItems, setVisibleItems] = useState([]);
  // State for hover tracking
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Custom title text for the secondary title
  const titleText = "Review of Contemporary Financial Systems";

  // Staggered animation effect
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links (matching IndexEconomics)
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%",
    padding: "15px 20px",
    margin: "0",
    textDecoration: "none",
    borderBottom: "1px solid #eee",
    color: "black",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style (matching IndexEconomics)
  const hoverStyle = {
    backgroundColor: "#f9f9f9",
    color: "#034d28", // Dark Green text on hover
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
        width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText text={titleText} delay={80} />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              // Animation style (fade in and slide up)
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }),
              // Hover style
              ...(isHovered ? hoverStyle : {}),
            }}
            // Hover handlers
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexFinance;
